/**
 * civilengineerService — civil-engineer lookup API wrapper.
 */

const BASE_URL = "https://api.docity.co";

function getAuthHeaders(extra = {}) {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extra,
  };
}

async function request(endpoint, options = {}) {
  try {
    const res = await fetch(`${BASE_URL}${endpoint}`, {
      ...options,
      headers: getAuthHeaders(options.headers),
    });
    const json = await res.json();
    return json;
  } catch (err) {
    console.error(`civilengineerService ${endpoint}:`, err);
    return { message: "Error", error: err.message };
  }
}

const civilengineerService = {
  /** Get a single civil engineer's data by userId. */
  getCivilEngData(data) {
    return request("/getCivilEngData", {
      method: "POST",
      body: JSON.stringify(data),
    });
  },

  /** Edit civil engineer data. */
  editCivilEngData(data) {
    return request("/editCivilEngData", {
      method: "PUT",
      body: JSON.stringify(data),
    });
  },

  /** Get all civil engineers. */
  getAllCivilEngs() {
    return request("/getAllCivilEngs", {
      method: "GET",
    });
  },
};

export default civilengineerService;
